var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWindDirectionArrow = function SvgWindDirectionArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.365 7.435 5.7 19.1a.56.56 0 0 1-.395.172.54.54 0 0 1-.405-.172.55.55 0 0 1-.177-.4q0-.223.177-.4L16.565 6.635H9.638a.556.556 0 0 1-.567-.572.555.555 0 0 1 .567-.562l8.14-.001q.308 0 .515.207.207.208.207.514v8.14q0 .241-.165.405a.56.56 0 0 1-.407.163.555.555 0 0 1-.562-.567z"
  })));
};
export default SvgWindDirectionArrow;